module.exports = __webpack_public_path__ + "img/speaker.b4ed86b0.png";